"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SourceListTabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tabs = require("../../constants/Tabs");
var _SourceListTabs = require("./SourceListTabs.styled");
var _Reusable = require("../../constants/Reusable");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SourceListTabs = exports.SourceListTabs = function SourceListTabs(_ref) {
  var theme = _ref.theme,
    onTabChanged = _ref.onTabChanged,
    currentTab = _ref.currentTab;
  var presenter = 'speakers';
  var tabs = [presenter, _Tabs.MEDIA];
  var getMediaTitle = function getMediaTitle(tab) {
    if (tab === _Tabs.MEDIA) {
      return 'content';
    }
    return tab;
  };
  return _react["default"].createElement(_SourceListTabs.TabsContainer, {
    theme: theme
  }, tabs.map(function (tab) {
    return _react["default"].createElement(_SourceListTabs.Tab, {
      theme: theme,
      "data-testid": tab,
      key: tab,
      isActive: currentTab === tab,
      onClick: function onClick() {
        return onTabChanged(tab);
      },
      tabIndex: "0",
      onKeyDown: function onKeyDown(e) {
        return (0, _Reusable.handleEnterDown)(e, function () {
          return onTabChanged(tab);
        });
      }
    }, getMediaTitle(tab));
  }));
};
SourceListTabs.defaultProps = {
  theme: 'dark'
};
SourceListTabs.propTypes = {
  theme: _propTypes["default"].string,
  currentTab: _propTypes["default"].string,
  onTabChanged: _propTypes["default"].func
};
var _default = exports["default"] = (0, _react.memo)(SourceListTabs);